import React, { useCallback, useEffect, useState, } from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useCart } from 'react-use-cart'
import { useSelector, useDispatch } from 'react-redux'
import { setActivePage } from '../../slices/uiSlice'
import { Icon } from '../../components'

import './navbar.scss'
    
export const NavBar = ( { onOrderPanelPosition, orderPanelPosition }: any) => {
    const { activePage } = useSelector((state: any) => state.ui)
    const dispatch = useDispatch()
    const { totalItems } = useCart()
    const [isShownMenu, setIsShownMenu] = useState(false)

    const onShowMenu = useCallback((e: any) => {
        orderPanelPosition !== 0 && e.stopPropagation()
        setIsShownMenu(true)
    },[setIsShownMenu, orderPanelPosition])

    useEffect(() => {
        window.addEventListener('click', () => setIsShownMenu(false))

        return () => {
            window.removeEventListener('click', () => {})
        }
    },[])

    const pages = [
        {path: '/?activePage=0', title: 'Начало'},
        {path: `/product-pads?activePage=1`, title: 'Подложки'},
        {path: '/product-salver?activePage=2', title: 'Подноси'},
        {path: '/product-clocks?activePage=3', title: 'Часовници'},
        // {path: '/product-fruitBowls?activePage=4', title: 'Фруктиери'},
        {path: '/product-tables?activePage=5', title: 'Маси'},
        {path: '/other-product?activePage=6', title: 'Други'},
        {path: '/about-us?activePage=7', title: 'За нас'},
    ]

    const onActive = useCallback((e: any) => {
        dispatch(setActivePage(Number(e.currentTarget.id)))
    },[dispatch])

    return (
        <div>
            <div className='headr-info'>
                <span>
                    <span>★</span> РЪЧНО ИЗРАБОТЕНИ ЛУКСОЗНИ ПРОДУКТИ <span>★</span>  СЪЗДАДЕНИ С ЛЮБОВ <span>★</span> 
                </span>
                <div>
                    <a href="https://www.facebook.com/Art.Resin.Coaster" rel="noreferrer" target="_blank">
                        <Icon iconName='Facebook' size={20}/>
                    </a>

                    <a href=" https://www.instagram.com/_shineco_/" rel="noreferrer" target="_blank">
                        <Icon iconName='Instagram' size={20}/>
                    </a>
                    
                    <a href="https://www.tiktok.com/@_shineco_" rel="noreferrer" target="_blank">
                        <Icon iconName='Tiktok' size={20}/>
                    </a>
                </div>
            </div>
            <Navbar className={`navbar ${activePage === 0 ? 'navbar-home' : ''}`}>
                <div className='burger-menu' onClick={onShowMenu}>
                    <div />
                    <div />
                    <div />
                </div>
                <Link to={'/?activePage=0'} id='0' onClick={onActive} className='brand'><img src='/images/ShineCo.png' alt='ShineCo'/></Link>
                <Container>
                    <Nav className="me-auto" {...isShownMenu ? {style: {left: '0px'}} : {}}>
                        <div className='menu-title-for-phone' onClick={(e: any) => {e.stopPropagation()}}>
                            <Icon
                                iconName={'XLg'}
                                className='btn-close'
                                size={30}
                                onClick={() => setIsShownMenu(false)}
                            />
                        </div>
                        {
                            pages.map((page: any, index: any) => (
                                <Link className={`link ${activePage === index ? 'selected' : ''}`} key={index} to={page.path} id={index} onClick={onActive}>{page.title}</Link>
                            ))
                        }
                    </Nav>
                    <div className="bag">
                            <Icon
                                iconName={totalItems > 0 ? 'HandbagFill' : 'Handbag'}
                                color="rgb(174, 174, 174)"
                                size={30}
                                onClick={(e) => onOrderPanelPosition(e, isShownMenu)} id='show'
                            />
                            {
                            totalItems > 0 && 
                                <span>
                                {totalItems}
                                </span>
                            }
                        </div>
                </Container>
            </Navbar>
        </div>
        
    )
} 